module.exports = __webpack_public_path__ + "img/assfinet.6de780cc.png";